const iconAriaLabels = {
    Add: "plus sign icon",
    Analytics: "analytics donut graph icon",
    Apps: "multiple dot icon in a 3x3 grid",
    ArrowDown: "arrow pointing down icon",
    ArrowDropdown: "filled triangle pointing down icon",
    ArrowDropright: "filled triangle pointing right icon",
    ArrowDropup: "filled triangle pointing up icon",
    ArrowLeft: "arrow pointing left icon",
    ArrowOutward: "arrow pointing diagonally upward icon",
    ArrowRight: "arrow pointing right icon",
    ArrowUp: "arrow pointing up icon",
    Assistant: "rectangular speech bubble with plus symbol in middle icon",
    AttachFile: "vertical paperclip icon",
    Basket: "dot icon inside a shopping basket icon",
    Beverage: "three quarter filled drinking cup icon",
    Calendar: "calendar icon",
    Cancel: "x icon inside a circle",
    CardMembership: "membership card icon",
    Cartridge: "battery cartridge icon",
    CBD: "cross icon with CBD letters in center",
    Checkmark: "checkmark icon",
    CheckmarkCircle: "checkmark icon inside a circle",
    ChevronDown: "chevron icon pointing down",
    ChevronLeft: "chevron icon pointing left",
    ChevronRight: "chevron icon pointing right",
    ChevronUp: "chevron icon pointing up",
    Close: "X shaped icon to close",
    Code: "two chevrons pointing left and right",
    Copy: "duplicate papers as copy icon",
    Dangerous: "x icon inside an octagon",
    Dashboard: "squares and rectangles in a square-shaped collage icon",
    Deactivate: "circle icon with a 45-degree diagonal line inside",
    Delete: "trash can icon",
    Disturb: "horizontal line icon inside a circle",
    Dollar: "dollar sign icon",
    Dot: "filled circle icon",
    DragIndicator: "multiple dots in a 2x3 grid icon",
    Edibles: "half eaten cookie icon",
    Edit: "pencil icon",
    EditSquare: "pencil icon writing on a square",
    Error: "exclamation point in a circle icon",
    Export: "arrow pointing down for export icon",
    Extracts: "flower icon with six round petals",
    FileUpload: "arrow pointing up for file upload icon",
    Filter: "three stacked lines with threshold markers icon",
    FilterList: "three horizontal lines in shape of downward arrow icon",
    Flower: "marijuana leaf icon",
    Folder: "folder icon",
    FolderCreate: "create new folder icon",
    Graph: "ascending line graph below data points icon",
    Help: "question mark icon inside of a circle",
    History: "clock icon with counter clockwise arrow",
    Home: "house icon",
    HorizontalRule: "horizontal rule icon",
    ImagesMode: "scenic image in square icon",
    Import: "arrow pointing up for import icon",
    Info: "i icon inside of a filled circle",
    InfoOutlined: "i icon inside of a circle",
    Input: "arrow pointing right into box input icon",
    Integrate: "chevron left and right icons inside a box icon",
    Inventory: "hyphen symbol inside a box icon",
    Kebab: "three dots in a row icon",
    Label: "label arrow icon pointing right",
    Launch: "rocket icon",
    List: "three bullet points in a vertical list icon",
    Location: "location pin icon",
    LocationAdd: "location pin icon with a plus sign",
    Lock: "closed lock icon",
    LowPriority: "arrow pointing down list icon",
    Loyalty: "heart symbol inside corner of price tag icon",
    Menu: "three stacked lines icon",
    Merch: "tshirt icon",
    Merge: "two lines merging into one arrow icon",
    Miscellaneous: "circle pentagon square triangle icons in a square shape",
    Monitoring: "ascending line graph above bar graph icon",
    More: "three dots in a column icon",
    OpenInNew: "arrow pointing out of box icon",
    Organization: "office building icon",
    Payments: "cash icon",
    Percent: "percentage symbol icon",
    PersonAdd: "outline of a person from shoulder up icon with a plus sign",
    PersonOff: "slashed out outline of a person from shoulder up icon",
    Phone: "phone icon",
    Pill: "medicine pill bottle icon",
    Plant: "budding plant in a pot icon",
    PrePacked: "3D packing box taped shut icon",
    PreRoll: "thin cylinder icon with two lines of smoke",
    Print: "printer icon",
    Product: "square circle triangle icons in a triangle shape",
    Profile: "outline of a person from shoulder up icon",
    ProfileGroup: "group outline of a person from shoulder up icon",
    ProfileGroupOff: "slashed out group outline of a person from shoulder up icon",
    Public: "globe icon",
    PublicOff: "slashed out globe icon",
    Radio: "circle with a dot in the middle icon",
    ReceiptLong: "long receipt icon",
    Redeem: "square box with gift wrapper",
    ChangeCircle: "a circle containing two arrow icons pointing in a counter-clockwise circle",
    Release: "checkmark inside badge icon",
    Remove: "minus sign icon",
    Restart: "counter-clockwise pointing arrow icon",
    Revoke: "octagon icon with X inside",
    Roles: "shield with person outline icon",
    Scan: "qr code icon",
    Schedule: "clock icon with hour and minute hand",
    Search: "magnifying glass icon",
    Settings: "gear icon",
    ShoppingCart: "shopping cart icon",
    Signout: "arrow inside door pointing outside icon",
    Store: "storefront icon",
    Success: "checkmark inside circle icon",
    Sync: "two arrow icons pointing in a counter-clockwise circle",
    Tag: "price tag icon",
    Task: "checkmark icon inside of a circle",
    ThumbsUp: "thumbs up icon",
    Tincture: "liquid dropper icon",
    Topical: "palm up hand icon with liquid droplet above",
    TrendingDown: "line with arrow trending down icon",
    TrendingUp: "line with arrow trending up icon",
    UnfoldLess: "unfold less icon",
    UnfoldMore: "unfold more icon",
    Unlock: "open lock icon",
    Users: "outline of a person from shoulder up within a circle icon",
    ViewColumn: "view column icon",
    VisibilityOff: "eye icon for visibility off",
    VisibilityOn: "eye icon for visibility on",
    Warning: "exclamation point inside a triangle icon",
};
export default iconAriaLabels;
